import React, { useRef } from "react"
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api"
import { GoogleMapKey } from "../../../../../helpers/MapHelper.js"
import { toAbsoluteUrl } from "../../../../../../_metronic/_helpers/index.js"
import { ICON_CONSTANTS } from "../../../../../../constants/ImageConstants.js"
import { Skeleton } from "@material-ui/lab"

export const BaseMap = ({ latitude, longitude, className = "", zoom = 15, options, icon }) => {
  const defaultOptions = {
    zoomControl: true,
    streetViewControl: false,
    cameraControl: false,
  }
  const containerStyle = {
    width: "100%",
    height: "400px"
  }

  const mapRef = useRef(null)

  const { isLoaded } = useLoadScript({
    googleMapsApiKey: GoogleMapKey()
  })

  const center = {
    lat: latitude ? parseFloat(latitude) : -6.2088,
    lng: longitude ? parseFloat(longitude) : 106.8456
  }

  if (!isLoaded) {
    return <Skeleton width={containerStyle.width} height={containerStyle.height} />
  }

  return (
    <GoogleMap
      mapContainerStyle={containerStyle}
      center={center}
      zoom={zoom}
      mapContainerClassName={className}
      options={options ? {
        ...defaultOptions,
        ...options
      } : defaultOptions}
      mapTypeId={"satellite"}
      onLoad={(map) => {
        mapRef.current = map
        const btn = document.createElement("button")
        btn.type = "button"
        btn.title = "Use current location"
        btn.style.cssText =
          "width:40px;height:40px;background:#fff;border:none;border-radius:8px;" +
          "box-shadow:0 2px 8px rgba(0,0,0,0.18);display:flex;align-items:center;" +
          "justify-content:center;cursor:pointer;padding:0;margin:0 10px 0 0;"
        const img = document.createElement("img")
        img.src = toAbsoluteUrl(ICON_CONSTANTS.FOCUS)
        img.alt = "current location"
        img.style.cssText = "width:20px;height:20px;"
        btn.appendChild(img)
        btn.addEventListener("click", () => {
          navigator?.geolocation.getCurrentPosition(
            ({ coords: { latitude: lat, longitude: lng } }) => {
              mapRef.current?.panTo({ lat, lng })
            },
            null
          )
        })
        map.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(btn)
      }}>
      <Marker
        position={center}
        icon={toAbsoluteUrl(icon ?? ICON_CONSTANTS.MARKER_BASECAMP)}
      />
    </GoogleMap>
  )
}

